import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { CardsContent } from './CardsContent'
import { useGetCards } from './useGetCards'
import { TileFilter } from '../shared/TileFilter'

export const CardsComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetCards(id, tileFilterSelections)

  return (
    <CardsContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function CardsComponentLoading() {
  return 'Loading...'
}
